<script>
  export let validationError = null;
  export let error = undefined;
</script>

{#if error}
  <div class="field-error" {...$$props}>
    {@html validationError}
  </div>
{/if}

<style lang="scss" src="./error.scss"></style>
